import React, { useState, useMemo } from "react";
import Header from "./Header";
import Nse from "./Nse";
import Mcx from "./Mcx";
import Options from "./Options";
import useSize from "../../../../../Utils/useSize/useSize";

export default function AddSymbol({ close }) {
  const windowSize = useSize();
  const [type, setType] = useState(1);

  // map type → component
  const renderComponent = useMemo(() => {
    switch (type) {
      case 1: return <Nse />;
      case 2: return <Mcx />;
      case 3: return <Options />;
      default: return <Nse />;
    }
  }, [type]);

  return (
    <div
      className="modal addModal border-4 border-[var(--hover)]"
      style={{
        borderRadius: 8,
        height: windowSize[1] * 0.9,
        width: windowSize[0] * 0.55,
        backdropFilter: "blur(5px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      <Header type={type} close={close} chnage={setType} />

      <div
        style={{
          padding: 12,
          maxHeight: "100%",
          overflowY: "auto",
          flex: 1,
          background: "var(--background)"
        }}
      >
        {renderComponent}
      </div>
    </div>
  );
}
